import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import ScrollToTop from "@/components/ScrollToTop";
import Homepage from "@/pages/Homepage";
import About from "@/pages/About";
import Programs from "@/pages/Programs";
import HowItWorks from "@/pages/HowItWorks";
import ScholarshipModel from "@/pages/ScholarshipModel";
import Inquiry from "@/pages/Inquiry";
import StudentApplication from "@/pages/StudentApplication";
import StudentApplicationSpanish from "@/pages/StudentApplicationSpanish";
import AccommodationsPage from "@/pages/AccommodationsPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/about" element={<About />} />
          <Route path="/programs" element={<Programs />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/scholarship-model" element={<ScholarshipModel />} />
          <Route path="/contact" element={<Inquiry />} />
          <Route path="/apply" element={<StudentApplication />} />
          <Route path="/apply/es" element={<StudentApplicationSpanish />} />
          <Route path="/accommodations" element={<AccommodationsPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
